/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Warning_Duration_LabelInputs */



/**
* | output |
* | --- |
* | "Duration" |
*
* @param {Event_Warning_Duration_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_warning_duration_label = /** @type {((inputs?: Event_Warning_Duration_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Warning_Duration_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Durée")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dauer")
	if (locale === "it") return /** @type {LocalizedString} */ ("Durata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Продолжительность")
	if (locale === "es") return /** @type {LocalizedString} */ ("Duración")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("期间")
	if (locale === "ja") return /** @type {LocalizedString} */ ("間隔")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अवधि")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Duração")
	return /** @type {LocalizedString} */ ("Duration")
});